import React from 'react';
import { ButtonStyled } from './styled';
import PropTypes from 'prop-types';

const Button = React.memo(
  ({
    onClick,
    children,
    btnType = 'primary',
    width,
    height = 40,
    maxWidth = null,
    fontSize = 14,
    minWidth = '',
    fontWeight = 'normal',
    hoverData = null,
    disabled = false,
    className = '',
    classNameChildren = '',
    ...rest
  }) => {
    const isDisabled = btnType === 'disabled' || disabled;

    const parseHeight = (value) => {
      if (typeof value === 'number') return value;
      const trimmed = value?.trim();
      if (/^\d+px$/.test(trimmed)) {
        return parseInt(trimmed.replace('px', ''), 10);
      }
      if (/^\d+$/.test(trimmed)) {
        return parseInt(trimmed, 10);
      }
      return 40;
    };

    const parseWidth = (value) => {
      if (typeof value === 'number') return value;
      const trimmed = value?.trim();
      if (/^\d+px$/.test(trimmed)) {
        return parseInt(trimmed.replace('px', ''), 10);
      }
      if (/^\d+$/.test(trimmed)) {
        return parseInt(trimmed, 10);
      }
      return '';
    };

    return (
      <ButtonStyled
        $btnType={btnType}
        $width={parseWidth(width)}
        $height={parseHeight(height)}
        $fontSize={fontSize}
        className={className}
        onClick={isDisabled ? undefined : onClick}
        $hoverData={hoverData}
        $maxWidth={maxWidth}
        $minWidth={minWidth}
        disabled={isDisabled}
        aria-disabled={isDisabled}
        style={{ ...(rest?.style || {}), letterSpacing: '0' }}
        {...rest}
      >
        <div
          className={`flex gap-1 text-center ${classNameChildren}`}
          style={{ fontWeight, letterSpacing: '0px' }}
        >
          {children}
        </div>
      </ButtonStyled>
    );
  }
);

Button.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  btnType: PropTypes.oneOf([
    'primary',
    'outline',
    'auth-back',
    'secondary',
    'back',
    'disabled',
  ]),
  disabled: PropTypes.bool,
  width: PropTypes.number,
  classNameChildren: PropTypes.string,
  className: PropTypes.string,
  fontSize: PropTypes.number,
  fontWeight: PropTypes.string,
  minWidth: PropTypes.number,
  height: PropTypes.number,
  hoverData: PropTypes.shape({
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    borderColor: PropTypes.string,
  }),
};

Button.displayName = 'Button';

export default Button;
